// Import Actions
import { SET_THEMES } from './ThemeActions';
import { LOGOUT_USER } from '../User/AuthActions';
import { SET_IS_FETCHING } from '../App/AppActions';

// Initial State
export const initialState = {
    data: [],
    isFetching: false,
};

// Think to update reducers.js

const ThemeReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_THEMES:
            return {
                ...state,
                data: action.themes,
                isFetching: false,
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'themes') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default ThemeReducer;
